import { IPagination } from 'app/types/common';

export interface IFixtureMatchesState {
  readonly fixtureMatchesById?: any;
  readonly fixtureMatchIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectFixtureMatchLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddFixtureMatch?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationFixtureMatchIds?: string[];
  readonly currentFixtureMatchId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IFixtureMatchesSelector extends IFixtureMatchesState {
  readonly currentFixtureMatch?: any;
  readonly currentFormFixtureMatch?: any;
  readonly getFixtureMatchesFilteredByTagInSelectFormat?: any;
  readonly fixtureMatchesByIdInSelectFormat?: any;
  readonly fixtureMatchesByIdSortedDate?: any;
}

export enum FixtureMatchesActionTypes {
  GET_ALL_FIXTURE_MATCHS_REQUESTED = 'redux-app/fixture-matchs/GET_ALL_FIXTURE_MATCHS_REQUESTED',
  GET_ALL_FIXTURE_MATCHS_PENDING = 'redux-app/fixture-matchs/GET_ALL_FIXTURE_MATCHS_PENDING',
  GET_ALL_FIXTURE_MATCHS_SUCCESS = 'redux-app/fixture-matchs/GET_ALL_FIXTURE_MATCHS_SUCCESS',
  GET_ALL_FIXTURE_MATCHS_FAIL = 'redux-app/fixture-matchs/GET_ALL_FIXTURE_MATCHS_FAIL',
  GET_FIXTURE_MATCH_REQUESTED = 'redux-app/fixture-matchs/GET_FIXTURE_MATCH_REQUESTED',
  GET_FIXTURE_MATCH_PENDING = 'redux-app/fixture-matchs/GET_FIXTURE_MATCH_PENDING',
  GET_FIXTURE_MATCH_SUCCESS = 'redux-app/fixture-matchs/GET_FIXTURE_MATCH_SUCCESS',
  GET_FIXTURE_MATCH_FAIL = 'redux-app/fixture-matchs/GET_FIXTURE_MATCH_FAIL',
  UPDATE_FIXTURE_MATCH_REQUESTED = 'redux-app/fixture-matchs/UPDATE_FIXTURE_MATCH_REQUESTED',
  UPDATE_FIXTURE_MATCH_PENDING = 'redux-app/fixture-matchs/UPDATE_FIXTURE_MATCH_PENDING',
  UPDATE_FIXTURE_MATCH_SUCCESS = 'redux-app/fixture-matchs/UPDATE_FIXTURE_MATCH_SUCCESS',
  UPDATE_FIXTURE_MATCH_FAIL = 'redux-app/fixture-matchs/UPDATE_FIXTURE_MATCH_FAIL',
  CREATE_FIXTURE_MATCH_REQUESTED = 'redux-app/fixture-matchs/CREATE_FIXTURE_MATCH_REQUESTED',
  CREATE_FIXTURE_MATCH_PENDING = 'redux-app/fixture-matchs/CREATE_FIXTURE_MATCH_PENDING',
  CREATE_FIXTURE_MATCH_SUCCESS = 'redux-app/fixture-matchs/CREATE_FIXTURE_MATCH_SUCCESS',
  CREATE_FIXTURE_MATCH_FAIL = 'redux-app/fixture-matchs/CREATE_FIXTURE_MATCH_FAIL',
  DELETE_FIXTURE_MATCH_REQUESTED = 'redux-app/fixture-matchs/DELETE_FIXTURE_MATCH_REQUESTED',
  DELETE_FIXTURE_MATCH_PENDING = 'redux-app/fixture-matchs/DELETE_FIXTURE_MATCH_PENDING',
  DELETE_FIXTURE_MATCH_SUCCESS = 'redux-app/fixture-matchs/DELETE_FIXTURE_MATCH_SUCCESS',
  DELETE_FIXTURE_MATCH_FAIL = 'redux-app/fixture-matchs/DELETE_FIXTURE_MATCH_FAIL',
  SELECT_FIXTURE_MATCH_REQUESTED = 'redux-app/fixture-matchs/SELECT_FIXTURE_MATCH_REQUESTED',
}

export default null;
